import React from 'react'
import GiftCardBalanceAction from './components/GiftCardBalanceAction/GiftCardBalanceAction'
import ReturnItemAction from './components/ReturnItemAction/ReturnItemAction'
import useGiftActions, {
  WriteReviewActionVariant,
} from './hooks/useGiftActions/useGiftActions'
import ActivateSubscriptionAction from './components/ActivateSubscriptionAction/ActivateSubscriptionAction'
import WriteReviewAction from './components/WriteReviewAction/WriteReviewAction'
import UnmarkAction from './components/UnmarkAction/UnmarkAction'
import { GiftActionsProps } from './GiftActions.types'
import ReturnInstructionsAction from './components/ReturnInstructionsAction/ReturnInstructionsAction'
import css from './GiftActions.styles.scss'

const GiftActions: React.FC<GiftActionsProps> = ({
  onUnmarkedAsPurchased,
  reservation,
}) => {
  const {
    isActivateSubscriptionEnabled,
    isGiftCardBalanceEnabled,
    isReturnItemEnabled,
    isReturnInstructionsEnabled,
    isUnmarkPurchaseEnabled,
    isWriteReviewEnabled,
    returnInstructionsUrl,
    showGiftActions,
    writeReviewVariant,
  } = useGiftActions(reservation)

  if (!showGiftActions) {
    return null
  }

  return (
    <div className={css.GiftActions}>
      {isActivateSubscriptionEnabled && (
        <ActivateSubscriptionAction reservation={reservation} />
      )}
      {isWriteReviewEnabled && (
        <WriteReviewAction
          reservation={reservation}
          variant={writeReviewVariant as WriteReviewActionVariant}
        />
      )}
      {isGiftCardBalanceEnabled && <GiftCardBalanceAction />}
      {isReturnItemEnabled && <ReturnItemAction reservation={reservation} />}
      {isReturnInstructionsEnabled && (
        <ReturnInstructionsAction
          reservation={reservation}
          returnInstructionsUrl={returnInstructionsUrl}
        />
      )}
      {isUnmarkPurchaseEnabled && (
        <UnmarkAction
          reservation={reservation}
          onUnmarkedAsPurchased={onUnmarkedAsPurchased}
        />
      )}
    </div>
  )
}

export default GiftActions
